import { AxiosError } from 'axios';
import { notification } from 'antd';

export interface WorkOrderErrorResponse {
  message: string;
  name: string;
  description: string;
  fieldErrors: Record<string, string[] | undefined>;
}

interface Props {
  error: unknown;
  messageDefault: (error: AxiosError) => void;
}

export default function notificationFieldErrorWorkOrder({
  error,
  messageDefault,
}: Props) {
  const err = error as AxiosError<WorkOrderErrorResponse>;

  const { fieldErrors } = err.response?.data || {};

  if (!fieldErrors || !Object.keys(fieldErrors).length) {
    messageDefault(err);
    return;
  }

  Object.entries(fieldErrors).forEach(([field, messages]) => {
    const description = messages?.[0];

    if (!description?.length) {
      return;
    }

    notification.error({
      message: ['CustomerId', 'InsurerId', 'CompanyId'].includes(field)
        ? 'Erro de vínculo'
        : 'Erro de validação',
      description,
    });
  });
}
